import React from 'react';
import { useStore } from '../../store/useStore';
import { Input, Textarea, Tabs, DocumentUpload, AudioUpload, GalleryUpload } from '../ui';
import { TrendingUp, Users, Activity, Route, FileArchive } from 'lucide-react';

export function M7_Sales() {
  const { salesProcess, setSalesProcess } = useStore();

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSalesProcess({ [e.target.name]: e.target.value });
  };

  const tabs = [
    {
      id: 'jornada',
      label: 'Jornada do Cliente',
      icon: <Route size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6 space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
               <Textarea 
                 label="1. Entrada do Lead" 
                 name="comoEntra" 
                 value={salesProcess.comoEntra} 
                 onChange={handleTextChange} 
                 placeholder="Como o lead chega? (WhatsApp, Formulário, Direct...)" 
                 className="min-h-[120px]"
               />
               <Textarea 
                 label="2. Quem atende e como?" 
                 name="quemAtende" 
                 value={salesProcess.quemAtende} 
                 onChange={handleTextChange} 
                 placeholder="Pré-vendedor? SDR? O dono?" 
                 className="min-h-[120px]"
               />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
               <Textarea 
                 label="3. Qualificação e Filtro" 
                 name="comoQualifica" 
                 value={salesProcess.comoQualifica} 
                 onChange={handleTextChange} 
                 placeholder="Quais as perguntas chave para saber se o lead é bom?" 
                 className="min-h-[120px]"
               />
               <Textarea 
                 label="4. Apresentação da Proposta" 
                 name="comoApresenta" 
                 value={salesProcess.comoApresenta} 
                 onChange={handleTextChange} 
                 placeholder="Reunião online? PDF por WhatsApp? Visita?" 
                 className="min-h-[120px]"
               />
            </div>
            <div className="max-w-3xl">
               <Textarea 
                 label="5. Fechamento e Follow-up" 
                 name="comoFecha" 
                 value={salesProcess.comoFecha} 
                 onChange={handleTextChange} 
                 placeholder="Como é a pressão para fechamento? Como faz follow-up?" 
                 className="min-h-[150px]"
               />
            </div>
        </div>
      )
    },
    {
      id: 'metricas',
      label: 'Métricas e Equipe',
      icon: <Activity size={16} />,
      content: (
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-white p-5 rounded-xl border border-gray-200 flex items-center justify-between shadow-sm">
                 <div>
                    <p className="text-sm font-medium text-gray-500">Ticket Médio Estimado</p>
                    <div className="flex items-center gap-1 mt-1">
                      <span className="text-sm text-gray-400">R$</span>
                      <span className="text-2xl font-bold text-gray-900">{salesProcess.ticketMedio || '0.00'}</span>
                    </div>
                 </div>
                 <div className="w-10 h-10 rounded-lg bg-green-50 flex items-center justify-center text-green-600">
                   <TrendingUp size={20} />
                 </div>
              </div>
              <div className="bg-white p-5 rounded-xl border border-gray-200 flex items-center justify-between shadow-sm">
                 <div>
                    <p className="text-sm font-medium text-gray-500">Taxa de Conversão</p>
                    <div className="flex items-center gap-1 mt-1">
                      <span className="text-2xl font-bold text-gray-900">{salesProcess.taxaConversao || '0'}</span>
                      <span className="text-sm text-gray-400">%</span>
                    </div>
                 </div>
                 <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
                   <Activity size={20} />
                 </div>
              </div>
              <div className="bg-white p-5 rounded-xl border border-gray-200 flex items-center justify-between shadow-sm">
                 <div>
                    <p className="text-sm font-medium text-gray-500">Tamanho da Equipe</p>
                    <div className="flex items-center gap-1 mt-1">
                      <span className="text-2xl font-bold text-gray-900">{salesProcess.numeroVendedores || '0'}</span>
                      <span className="text-sm text-gray-400">Vendedores</span>
                    </div>
                 </div>
                 <div className="w-10 h-10 rounded-lg bg-purple-50 flex items-center justify-center text-purple-600">
                   <Users size={20} />
                 </div>
              </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
             <div className="p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                 <div className="relative">
                     <Input label="Ticket Médio Real" name="ticketMedio" value={salesProcess.ticketMedio} onChange={handleTextChange} placeholder="0,00" className="pl-9" />
                     <span className="absolute left-3 top-8 text-gray-500 font-medium text-sm border-r border-gray-200 pr-1">R$</span>
                 </div>
                 <div className="relative">
                     <Input label="Taxa Conversão Média" name="taxaConversao" value={salesProcess.taxaConversao} onChange={handleTextChange} placeholder="0" className="pr-8" />
                     <span className="absolute right-3 top-8 text-gray-500 font-medium text-sm border-l border-gray-200 pl-1">%</span>
                 </div>
                 <Input label="Ciclo de Venda Médio" name="cicloVenda" value={salesProcess.cicloVenda} onChange={handleTextChange} placeholder="Ex: 7 dias, Imediato..." />
                 <Input label="Qtd Vendedores" type="number" name="numeroVendedores" value={salesProcess.numeroVendedores} onChange={handleTextChange} placeholder="Total na equipe" />
             </div>
          </div>
        </div>
      )
    },
    {
      id: 'material',
      label: 'Material Tático',
      icon: <FileArchive size={16} />,
      content: (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6 space-y-8">
           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
               <DocumentUpload 
                 label="Script Comercial Atual"
                 description="Faça o upload de PDFs, Docs de roteiros de vendas ou playbooks."
                 onChange={(files) => setSalesProcess({ scripts: files as any })}
               />
               <AudioUpload 
                 label="Áudios de Vendas Reais"
                 description="Suba exemplos (mp3/wav) de ligações ou áudios de WhatsApp de vendedores aplicando o roteiro."
                 onChange={(files) => setSalesProcess({ audios: files as any })}
               />
           </div>
           
           <div className="pt-6 border-t border-gray-100">
               <GalleryUpload 
                 label="Prints do Funil do CRM"
                 description="Capture a tela de como estão os pipelines e as etapas de venda no sistema atual."
                 onChange={(files) => setSalesProcess({ funilPrints: files as any })}
               />
           </div>
        </div>
      )
    }
  ];

  return <Tabs tabs={tabs} />;
}
